import * as Yup from 'yup';
import { useState, useEffect } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';

// material
import {
  Link,
  Stack,
  Checkbox,
  TextField,
  IconButton,
  InputAdornment,
  FormControlLabel,
  Snackbar
} from '@mui/material';
import Alert from '@mui/material/Alert';
import { LoadingButton } from '@mui/lab';
import { api } from '../../../Api';
// component
import Iconify from '../../../components/Iconify';
import { Decryption } from 'src/functions/function';
import Helper from '../../../Helper';
// ----------------------------------------------------------------------

export default function LoginForm() {
  const [alert, setalert] = useState({ visible: false, message: '' });
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [isSubmitting, setisSubmitting] = useState(false);
  const [isPhone, setisPhone] = useState(false);

  const LoginSchema = Yup.object().shape({
    email: Yup.string()
      .required('Bussiness Email is required')
      .test('valid-key', 'Please enter a valid email address', function (value) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        return emailRegex.test(value);
      }),
    password: Yup.string().required('Password is required')
  });

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
      remember: false
    },
    validationSchema: LoginSchema,
    onSubmit: () => {
      LoginFunction();
    }
  });

  const { errors, touched, values, handleSubmit, getFieldProps, setFieldValue } = formik;

  // Load credentials from local storage when the component mounts.
  const savedEmail = localStorage.getItem('email');
  const savedPassword = localStorage.getItem('password');
  const rememberMe = localStorage.getItem('remember') === 'true';
  useEffect(() => {
    if (savedEmail && savedPassword) {
      setFieldValue('email', savedEmail);
      setFieldValue('password', savedPassword);
      setFieldValue('remember', rememberMe);
    }
  }, [setFieldValue]);

  const handleShowPassword = () => {
    setShowPassword((show) => !show);
  };

  const LoginFunction = () => {
    setisSubmitting(true);
    var formdata = new FormData();
    formdata.append('email', values?.email);
    formdata.append('password', values?.password);
    const requestOptions = {
      method: 'POST',
      body: formdata,
      redirect: 'follow'
    };
    fetch(api.Login, requestOptions)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else {
          return response.json().then((error) => {
            console.log('result =====>>>>>credentail', error);
            setalert({ visible: true, message: error.error });
          });
        }
      })
      .then((result) => {
        if (result.success === true) {
          localStorage.setItem('token', result.data?.token);
          localStorage.setItem('user', JSON.stringify(result?.user));
          if (values.remember) {
            // Save credentials to local storage
            localStorage.setItem('email', values.email);
            localStorage.setItem('password', values.password);
            localStorage.setItem('remember', values.remember);
          } else {
            // Remove credentials from local storage
            localStorage.removeItem('email');
            localStorage.removeItem('password');
            localStorage.removeItem('remember');
          }

          getSideBar(result.data?.token, result?.path);
          // navigate('edit_profile');
        } else {
          setalert({ visible: true, message: result.message });
          console.log('false aa rah aha');
          if (result?.code) {
            console.log('code m aa rah aha');

            localStorage.setItem('email', values.email);

            console.log('code ', result?.code);
            navigate('/otpVerification', {
              replace: true,
              state: {
                user: '',
                token: '',
                message: result?.message,
                code: result?.code,
                email: values.email
              }
            });
          }
        }
      })
      .catch((error) => {
        setisSubmitting(false);
        setalert({ visible: true, message: 'An error occurred.', color: 'error' });
      })
      .finally(() => {
        setisSubmitting(false);
      });
  };

  function getSideBar(token, path) {
    console.log('🚀 ~ getSideBar ~ path:', path);

    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);
    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(api.sidebar, requestOptions)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else {
          throw new Error('Failed to fetch sidebar data');
        }
      })
      .then((result) => {
        let decryptedData = Decryption(result.data);
        console.log(decryptedData, 'YE CHECK KRW');
        localStorage.setItem('permissions', JSON.stringify(decryptedData));
        setTimeout(() => {
          navigate(path, { replace: true });
        }, 1000);
      })
      .catch((error) => {
        console.log('error', error);
      })
      .finally(() => {
        setisSubmitting(false);
      });
  }

  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
        <Stack spacing={3}>
          <TextField
            fullWidth
            autoComplete="username"
            type="email"
            label="Business Email"
            {...getFieldProps('email')}
            error={Boolean(touched.email && errors.email)}
            helperText={touched.email && errors.email}
          />

          <TextField
            fullWidth
            autoComplete="current-password"
            type={showPassword ? 'text' : 'password'}
            label="Password"
            {...getFieldProps('password')}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleShowPassword} edge="end">
                    <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                  </IconButton>
                </InputAdornment>
              )
            }}
            error={Boolean(touched.password && errors.password)}
            helperText={touched.password && errors.password}
          />
        </Stack>

        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }}>
          <FormControlLabel
            control={<Checkbox {...getFieldProps('remember')} checked={values.remember} />}
            label="Remember me"
          />
          <Link component={RouterLink} variant="subtitle2" to="/forgot" underline="hover">
            Forgot password?
          </Link>
        </Stack>

        {alert.visible && (
          <Alert
            onClose={() => {
              setalert({ visible: false, message: '' });
            }}
            severity="error"
            style={{ fontSize: 12, marginBottom: 20 }}
          >
            {alert.message}
          </Alert>
        )}

        <LoadingButton
          fullWidth
          size="large"
          type="submit"
          variant="contained"
          loading={isSubmitting}
        >
          Login
        </LoadingButton>
      </Form>
      <LoadingButton
        style={{ marginTop: 10 }}
        fullWidth
        size="large"
        variant="outlined"
        onClick={() => {
          navigate('/signup');
        }}
      >
        Sign up
      </LoadingButton>
    </FormikProvider>
  );
}
